module.exports = __webpack_public_path__ + "assets/img/Type E (59).ff71e01e.jpg";